import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectData, BimCreateContractObjectMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';

import { bimCreateContractObjectGql } from '../BimContractStructureRequests';

interface IUseBimCreateContractObject {
    onSuccess: (item: BimContractObjectData) => void;
    onClose: () => void;
    refreshProject: () => void;
    bimContractObjectsMakeRequest: () => void;
}

const requestId = 'bimCreateContractObject';

export const useBimCreateContractObject = (props: IUseBimCreateContractObject) => {
    const { onClose, onSuccess, refreshProject, bimContractObjectsMakeRequest } = props;

    const [resetBimCreateContractObject] = useResetStoreData({ requestId: 'bimCreateContractObject' });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimCreateContractObjectMutation>) => {
            if (depsVars?.payload?.bimCreateContractObject?.data) {
                onSuccess(depsVars?.payload?.bimCreateContractObject?.data);
            }
            bimContractObjectsMakeRequest();
            refreshProject();
            onClose();
            resetBimCreateContractObject(undefined);
        },
        [bimContractObjectsMakeRequest, onClose, onSuccess, refreshProject, resetBimCreateContractObject],
    );

    const [, , , bimCreateContractObjectRequest] = useRequest<BimCreateContractObjectMutation>({
        requestId,
        query: bimCreateContractObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return bimCreateContractObjectRequest;
};
